import { auth } from '../utils/firebase'

const HEARTBEAT_ACTIVITY_KEY = 'tydy_heartbeat_activity_at'
const ACTIVITY_THROTTLE_MS = 30 * 60 * 1000

export type HeartbeatActivityResult = 'recorded' | 'throttled' | 'unavailable'

let pendingActivity: Promise<HeartbeatActivityResult> | null = null

async function sendForegroundActivity(): Promise<HeartbeatActivityResult> {
  const user = auth.currentUser
  if (!user) return 'unavailable'
  const searchParams = new URLSearchParams(window.location.search)
  const heartbeatSignalId = searchParams.get('heartbeatSignal')?.trim()
  const previous = Number(localStorage.getItem(HEARTBEAT_ACTIVITY_KEY) || 0)
  if (!heartbeatSignalId && previous && Date.now() - previous < ACTIVITY_THROTTLE_MS) return 'throttled'

  const token = await user.getIdToken()
  const headers: Record<string, string> = { Authorization: `Bearer ${token}` }
  if (heartbeatSignalId) headers['Content-Type'] = 'application/json'
  const response = await fetch('/api/heartbeat/activity', {
    method: 'POST',
    headers,
    body: heartbeatSignalId ? JSON.stringify({ heartbeatSignalId }) : undefined,
  })
  if (!response.ok) throw new Error('Heartbeat activity could not be recorded.')
  if (heartbeatSignalId) {
    searchParams.delete('heartbeatSignal')
    const search = searchParams.toString()
    window.history.replaceState(
      window.history.state,
      '',
      `${window.location.pathname}${search ? `?${search}` : ''}${window.location.hash}`,
    )
  }
  localStorage.setItem(HEARTBEAT_ACTIVITY_KEY, String(Date.now()))
  return 'recorded'
}

export const heartbeatService = {
  recordForegroundPresence(): Promise<HeartbeatActivityResult> {
    if (pendingActivity) return pendingActivity
    pendingActivity = sendForegroundActivity().finally(() => {
      pendingActivity = null
    })
    return pendingActivity
  },
}
